exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bloc-course{max-width:610px!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/js/course/CourseList/CourseList.less
 ** module id = 509
 ** module chunks = 1
 **/